import NumberOfResultsPerPageFilter from './NumberOfResultsPerPageFilter.component';

export default NumberOfResultsPerPageFilter;